export const RoomState = {
  AVAILABLE: 'AVAILABLE',
  BOOKED: 'BOOKED',
  MAINTENANCE: 'MAINTENANCE',
  OCCUPIED: 'OCCUPIED'
};

export const Colors = {
  AVAILABLE: {red: 0, green: 255, blue: 0},
  OCCUPIED: {red: 255, green: 0, blue: 0},
  BOOKED: {red: 255, green: 140, blue: 0},
  MAINTENANCE: {red: 128, green: 0, blue: 128},
  red: {red: 255, green: 0, blue: 0},
  green: {red: 0, green: 255, blue: 0},
  off: {red: 0, green: 0, blue: 0}
};

// is this the parent window (as opposed to an iframe)
export const isParentWindow = !(window !== window.parent && !window.opener);
